import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { StoreModule } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects';
import { RouterModule } from '@angular/router';
// Reducers
import * as fromAccount from './account/account.reducer';
import * as fromApplication from './application/application.reducer';
import * as fromApplicationStatuses from './application-statuses/application-statuses.reducer';
import * as fromAuth from './auth/auth.reducer';
import * as fromModuleConfigs from './module-configs/module-configs.reducer';
import * as fromQueueFilter from './queue-filter/queue-filter.reducer';
import * as fromSupportCenter from './support-center/support-center.reducer';
import * as fromViewHeader from './view-header/view-header.reducer';
// Effects
import { AccountEffects } from './account/account.effects';
import { ApplicationEffects } from './application/application.effects';
import { ApplicationStatusesEffects } from './application-statuses/application-statuses.effects';
import { AuthEffects } from './auth/auth.effects';
import { ModuleConfigsEffects } from './module-configs/module-configs.effects';
import { QueueFilterEffects } from './queue-filter/queue-filter.effects';
import { SupportCenterEffects } from './support-center/support-center.effects';
import { ViewHeaderEffects } from './view-header/view-header.effects';
// Facades
import { AccountFacade } from './account/account.facade';
import { ApplicationFacade } from './application/application.facade';
import { ApplicationStatusesFacade } from './application-statuses/application-statuses.facade';
import { AuthFacade } from './auth/auth.facade';
import { ModuleConfigsFacade } from './module-configs/module-configs.facade';
import { QueueFilterFacade } from './queue-filter/queue-filter.facade';
import { SupportCenterFacade } from './support-center/support-center.facade';
import { ViewHeaderFacade } from './view-header/view-header.facade';

@NgModule({
  imports: [
    CommonModule,
    RouterModule,
    StoreModule.forFeature(
      fromAccount.ACCOUNT_FEATURE_KEY,
      fromAccount.reducer
    ),
    StoreModule.forFeature(
      fromApplication.APPLICATION_FEATURE_KEY,
      fromApplication.reducer
    ),
    StoreModule.forFeature(
      fromApplicationStatuses.APPLICATION_STATUSES_FEATURE_KEY,
      fromApplicationStatuses.reducer
    ),
    StoreModule.forFeature(fromAuth.AUTH_FEATURE_KEY, fromAuth.reducer),
    StoreModule.forFeature(
      fromModuleConfigs.MODULE_CONFIGS_FEATURE_KEY,
      fromModuleConfigs.reducer
    ),
    StoreModule.forFeature(
      fromQueueFilter.QUEUE_FILTER_FEATURE_KEY,
      fromQueueFilter.reducer
    ),
    StoreModule.forFeature(
      fromSupportCenter.SUPPORT_CENTER_FEATURE_KEY,
      fromSupportCenter.reducer
    ),
    StoreModule.forFeature(
      fromViewHeader.VIEW_HEADER_FEATURE_KEY,
      fromViewHeader.reducer
    ),
    EffectsModule.forFeature([AccountEffects]),
    EffectsModule.forFeature([ApplicationEffects]),
    EffectsModule.forFeature([ApplicationStatusesEffects]),
    EffectsModule.forFeature([AuthEffects]),
    EffectsModule.forFeature([ModuleConfigsEffects]),
    EffectsModule.forFeature([QueueFilterEffects]),
    EffectsModule.forFeature([SupportCenterEffects]),
    EffectsModule.forFeature([ViewHeaderEffects]),
  ],
  providers: [
    AccountFacade,
    ApplicationFacade,
    ApplicationStatusesFacade,
    AuthFacade,
    ModuleConfigsFacade,
    QueueFilterFacade,
    SupportCenterFacade,
    ViewHeaderFacade,
  ],
})
export class SharedStateMgmtModule {}

// NOTE: We intentionally only export the facades
// from this module. That forces consumers
// of state to only interact with NgRx through the simple
// facade API and not have to deal with
// actions, effects, reducers, and selectors.

export { ApplicationFacade } from './application/application.facade';
export { ApplicationEffects } from './application/application.effects';
export { ApplicationStatusesFacade } from './application-statuses/application-statuses.facade';
export { ApplicationStatusesEffects } from './application-statuses/application-statuses.effects';
export { AccountFacade } from './account/account.facade';
export { AccountEffects } from './account/account.effects';
export { AuthFacade } from './auth/auth.facade';
export { AuthEffects } from './auth/auth.effects';
export { ModuleConfigsFacade } from './module-configs/module-configs.facade';
export { ModuleConfigsEffects } from './module-configs/module-configs.effects';
export { QueueFilterFacade } from './queue-filter/queue-filter.facade';
export { QueueFilterEffects } from './queue-filter/queue-filter.effects';
export { ViewHeaderFacade } from './view-header/view-header.facade';
export { ViewHeaderEffects } from './view-header/view-header.effects';
export { SupportCenterFacade } from './support-center/support-center.facade';
export { SupportCenterEffects } from './support-center/support-center.effects';

// these need to be exported for an application resolver
export {
  ApplicationActionsUnion,
  getApplicationSuccess,
  getApplicationFailure,
  ApplicationActionTypes,
} from './application/application.actions';
